<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Novo razdoblje</h5>
            </div>
            <div class="ibox-content">
                <osoba-razdoblje-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                >
                </osoba-razdoblje-forma>
            </div>
        </div>
    </div>
</template>

<script>
import OsobeNavigation from "../OsobeNavigation";
import OsobaRazdobljeForma from "./OsobaRazdobljeForma";
export default {
    name: "OsobaRazdobljaCreate",
    components: { OsobaRazdobljeForma, OsobeNavigation },
    data(){
        return {
            breadcrumbs: [],
            osoba_id: this.$route.params.osoba_id
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/razdoblja',
                    name: 'Razdoblja'
                },
                {
                    path: '/osobe/' + this.osoba_id + '/razdoblja/create',
                    name: 'Novo razdoblje'
                }
            ]
        }
    },
    mounted() {
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
